<template>
  <div class="reg-dialog">
    <div class="title">新用户注册</div>
    <div class="content">
      <div class="telephone">
        <span>手机号</span>
        <el-input
          v-model="telephone"
          placeholder="请输入手机号"
          maxlength="11"
          size="medium"
        ></el-input>
        <div
          class="send-btn"
          :class="{ 'disabled-send-btn': sendingVerifyCode }"
          @click="sendVerifyCode"
        >
          {{ verifyCodeBtnText }}
        </div>
      </div>
      <div class="verifyCode">
        <span>验证码</span>
        <el-input
          v-model="verifyCode"
          placeholder="请输入验证码"
          size="medium"
        ></el-input>
      </div>
      <div class="password">
        <span>密码</span>
        <el-input
          v-model="password"
          show-password
          placeholder="请输入密码"
          size="medium"
        ></el-input>
      </div>
      <div class="tips">密码为6~20位，可由数字、字母、符合组成。</div>
      <div
        class="reg-btn"
        :click="{ 'disabled-btn': submitting }"
        @click="reg"
        v-loading="submitting"
      >
        确认注册
      </div>
      <div class="reg-tips">
        注册即代表同意<el-link
          href="/#/userProtocol"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《用户协议》</el-link
        >及<el-link
          href="/#/privacy"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《隐私政策》</el-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      telephone: "",
      verifyCode: "",
      password: "",
      rePassword: "",
      submitting: false,
      sendingVerifyCode: false,
      timerCounter: 60,
      verifyCodeBtnText: "发送验证码"
    };
  },
  methods: {
    async reg() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      if (this.telephone.length !== 11) {
        this.submitting = false;
        this.$message.error("请输入正确的手机号！");
        return;
      }
      if (this.verifyCode.length === 0) {
        this.submitting = false;
        this.$message.error("请输入验证码！");
        return;
      }
      if (this.password.length < 6 || this.password.length > 20) {
        this.submitting = false;
        this.$message.error("密码格式不符合要求！");
        return;
      }

      this.submitting = true;
      const params = {
        phone: this.telephone,
        password: this.password,
        checkCode: this.verifyCode
      };
      const res = await httpRequest("/app/user/register", "post", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.$message.success("注册成功，请登录");
        // 跳转到首页
        this.$router.push({ path: "/login" });
      } else {
        this.submitting = false;
      }
    },
    async sendVerifyCode() {
      if (this.submitting || this.sendingVerifyCode) {
        return;
      }
      if (this.telephone.length !== 11) {
        this.sendingVerifyCode = false;
        this.$message.error("请输入正确的手机号！");
        return;
      }
      this.sendingVerifyCode = true;
      const params = {
        phone: this.telephone
      };
      const res = await httpRequest("/common/sms", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        const _this = this;
        this.sendingVerifyCode = true;
        this.$message.success(
          "验证码已发送到" + this.telephone + "，请注意查收"
        );
        setInterval(function() {
          if (_this.timerCounter <= 0) {
            clearInterval();
            _this.verifyCodeBtnText = "重新发送";
            _this.sendingVerifyCode = false;
          } else {
            _this.verifyCodeBtnText = "重新发送(" + _this.timerCounter-- + "s)";
          }
        }, 1000);
      } else {
        this.sendingVerifyCode = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.reg-dialog {
  width: 850px;
  height: 544px;
  background: #ffffff;
  margin-top: 150px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  color: rgba(51, 51, 51, 1);
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 176, 171, 1);
  }
  .content {
    margin-left: 145px;
    margin-right: 145px;
    margin-top: 89px;
    .telephone {
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      span {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .el-input {
        width: 216px;
        margin-left: 46px;
      }
      .send-btn {
        display: inline-block;
        width: 123px;
        height: 36px;
        line-height: 36px;
        border: 1px solid rgba(0, 176, 171, 1);
        margin-left: 20px;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        border-radius: 4px;
        cursor: pointer;
      }
      .disabled-send-btn {
        color: lightgray !important;
        cursor: default !important;
      }
    }
    .verifyCode {
      margin-top: 35px;
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      span {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .el-input {
        width: 361px;
        margin-left: 46px;
      }
    }
    .password {
      margin-top: 35px;
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      span {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .el-input {
        width: 361px;
        margin-left: 46px;
      }
    }
    .tips {
      font-size: 12px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      margin-top: 10px;
      padding-left: 8px;
    }
    .reg-btn {
      height: 50px;
      line-height: 50px;
      background: rgba(0, 176, 171, 1);
      border-radius: 4px;
      margin-top: 60px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
    .reg-tips {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      text-align: center;
    }
    .disabled-btn {
      cursor: default !important;
    }
  }
}
</style>
